import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Form, Button, ButtonToolbar, Schema, FlexboxGrid, toaster, Message } from 'rsuite';
import { useHistory } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { FormEvent, useCallback, useState } from 'react';
import { getByFilter } from 'services/microsoftGraphApi';
import CryptoJS from 'crypto-js';
import { RequestVM } from 'models/requestVM';
import { ClipLoader } from 'react-spinners';
import { siteVerify } from 'services/googleRecaptcha';

const regexMail = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
const recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY + '';

export default function Comprobar(): React.ReactElement {
    return (
        <GoogleReCaptchaProvider language="es-CL" reCaptchaKey={recaptchaKey} scriptProps={{ async: true }}>
            <Comprobar2 />
        </GoogleReCaptchaProvider>
    );
}

function Comprobar2(): React.ReactElement {

    let [mail, setMail] = useState("");
    let [pass, setPass] = useState("");
    const [loadingInProgress, setLoading] = useState(false);
    const [isDisabledbutton, setDisibilityButton] = useState(true);
    const { executeRecaptcha } = useGoogleReCaptcha();

    const { StringType } = Schema.Types;
    const model = Schema.Model({
        email: StringType().isRequired('Este campo es requerido').isEmail('Por favor, ingrese un correo válido.'),
        password: StringType().isRequired('Este campo es requerido').isRequired('Este campo es requerido')
    });    

    const history = useHistory();    

    const handleChangeEmail = (val) => {
        setDisibilityButton(true);
        setMail(val);
        mail = val;  

        if (val != "")
        {
            if(regexMail.test(val) && pass.length >= 8)
            {
                setDisibilityButton(false);
            }              
        } 
    }; 

    const handleChangePass = (val2) => {
        setDisibilityButton(true);
        setPass(val2);
        pass = val2;

        if (val2 != "")
        {
            if(regexMail.test(mail) && pass.length >= 8)
            {
                setDisibilityButton(false);
            }                
        }             
    };
    
    const onSubmit = useCallback(
        (event: FormEvent) => {
            //event.preventDefault();

            if (!executeRecaptcha) return;
            (async () => {
            try {
                const token = await executeRecaptcha('callMicrosoftGraphAPI');

                if (token != null && token != undefined && token != '')
                {
                    const respuesta = await siteVerify(token);

                    if (respuesta.success && respuesta.score != null && respuesta.score >= 0.5)
                    {
                        const email2 = document.querySelector('#email') as HTMLInputElement;
                        const password2 = document.querySelector('#password') as HTMLInputElement;

                        setMail(email2.value);
                        setPass(password2.value);

                        callMicrosoftGraphAPI(email2.value, password2.value);
                    }
                    else
                    {
                        toaster.push(
                        <Message showIcon type="warning" header="Atención" duration={4000}>
                            No se pudo validar el token de recaptcha. Intente nuevamente.
                        </Message>, { placement: 'topEnd' });
                    }
                }
                else
                {
                    toaster.push(
                    <Message showIcon type="warning" header="Atención" duration={4000}>
                        No se pudo obtener un token de recaptcha
                    </Message>, { placement: 'topEnd' });
                }

            } catch (e) {
                toaster.push(
                <Message showIcon type="warning" header="Atención" duration={4000}>
                    No se pudo obtener un token de recaptcha
                </Message>, { placement: 'topEnd' });
            }
            })();
        },
        [executeRecaptcha]
    );    

    const callMicrosoftGraphAPI = async (mail, pass) => {

        if (mail == null || mail == '' || pass == null || pass == '') 
        {
            toaster.push(
            <Message showIcon type="warning" header="Atención" duration={4000}>
                Campos Requeridos.
            </Message>, { placement: 'topEnd' });
        }
        else 
        {
            setLoading(true);

            const model = new RequestVM(mail,pass,"",true,"","");
            const respuesta = await getByFilter(model);

            if (respuesta.success && respuesta.data.id != null)
            {
                // Encrypt
                var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(respuesta.data.id), 'my-secret-key@123').toString();
        
                let path = '/cambiocontrasena/' + ciphertext.toString();
                history.push(path);
            }
            else {
                setLoading(false);

                setMail("");
                setPass("");

                toaster.push(
                <Message showIcon type="warning" header="Atención" duration={4000}>
                    La cuenta usuario colaborador o contraseña erróneos
                </Message>, { placement: 'topEnd' });
            }
        }
    };

    const renderComprobar = (
        <Form model={model}>
            <Form.Group controlId="email">
                <Form.ControlLabel>Cuenta Usuario Colaborador</Form.ControlLabel>
                <Form.Control onChange={handleChangeEmail} value={mail} name='email' label='Cuenta Usuario Colaborador' />            
                <Form.HelpText tooltip>Correo es requerido</Form.HelpText>
            </Form.Group>         
            <Form.Group controlId="password">
                <Form.ControlLabel>Contraseña</Form.ControlLabel>
                <Form.Control type='password' onChange={handleChangePass} value={pass} name='password' autoComplete='off' minLength={8} maxLength={15}/>                                                                      
                <Form.HelpText tooltip>Mínimo 8 y máximo 15 caracteres</Form.HelpText>
            </Form.Group>          
            <ButtonToolbar style={{ marginTop: '5%', textAlign: 'right' }}>
                <Button appearance='primary' color='blue' type='submit' disabled={isDisabledbutton} onClick={onSubmit}>
                    Siguiente
                </Button>
            </ButtonToolbar>
        </Form>
    );

    return (
        <FlexboxGrid justify="center" align="middle" style={{ marginTop: '5%', backgroundColor: '#FFF' }}>
            {loadingInProgress ? (<ClipLoader color={'#000000'} size={150} />) : (renderComprobar)}      
        </FlexboxGrid>
    );  
}